<template>
  <div id="modal" v-if="data" v-bind:style="{ 'background': 'url(' + data.thumbURL + ') 0 0/cover' }">
    <div id="modal-content" v-if="data.type=='submit'">
      <div id="modal-title">
        <h3>{{data.name}}</h3>
        <h4 class="reservable" v-if="totalAvailable">{{totalAvailable}} available</h4>
      </div>
      <div class="modal-scrollable">
        <div class="mask-settings" v-for="(mask, i) in masksSummary" v-bind:key="i" :id="'mask' + i">
          <div class="summaryItem">
            {{mask.name}}: {{mask.quantity}}
          </div>
        </div>
        <div id="form">
          <input type="text" name="name" placeholder="name" v-model="form.name">
          <input type="text" name="email" placeholder="email" v-model="form.email">
          <input type="tel" name="number" placeholder="phone (optional)" v-model="form.phone">

          <div>
            Suggested donation ($5/mask)
          </div>
          <div class="mask-settings">
            <div class="row">

            <div class="col-12-sm">
              <div class="col-6-sm">
                <button id="cancel-button" class="subdued button" @click="closeModal">Cancel</button>
              </div>
              <div class="col-6-sm">
                <button id="add-button" class="button" v-bind:class="{subdued:!(form.name && form.email)}" @click="submit">
                  Submit!
                </button>
              </div>
            </div>
          </div>
          </div>
        </div>

      </div>
    </div>
    <div id="modal-content" v-else>
      <div id="modal-title">
        <h3>{{data.name}}</h3>
      </div>
      <div class="modal-scrollable">
        <div class="mask-settings" v-bind:class="{error: displayErrors && missingInfoSolo(mask)}" v-for="(mask, i) in desiredMasks" v-bind:key="i" :id="'mask' + i">
          {{i+1}}
          <div class="mask-option-group">
            <button class="mask-option button" v-bind:class="{selected: mask.type=='elastic'}" @click="setType(i, 'elastic')">elastic</button>
            <button class="mask-option button" v-bind:class="{selected: mask.type=='string'}" @click="setType(i, 'string')">string</button>
          </div>
          <div class="mask-option-group">
              <button class="mask-option button" v-bind:class="{selected: mask.size=='s'}" @click="setSize(i, 's')">s</button>
              <button class="mask-option button" v-bind:class="{selected: mask.size=='m'}" @click="setSize(i, 'm')">m</button>
              <button class="mask-option button" v-bind:class="{selected: mask.size=='l'}" @click="setSize(i, 'l')">l</button>
          </div>

          <div class="mask-option-group">
            <button @click="removeFromList(i)" class="delete-button button">
              <font-awesome-icon :icon="['fa', 'trash-alt']" /></button>
          </div>
          <div class="error-message" v-if="displayErrors && missingInfoSolo(mask)">
            Please select a type and a size
          </div>
        </div>
        <div class="mask-settings"
          id="add"
          @click="addToList">
          <span id="add-button" class="button" v-if="totalAvailable > 0">
            {{totalAvailable}} More Available
          </span>
        </div>
      </div>
    </div>
    <div id="modal-footer" v-if="data.type!='submit'">
      <div class="modal-footer-button" id="cancel" @click="closeModal">Cancel</div>
      <div class="modal-footer-button" id="reserve" @click="addToReservation">Add to My List</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    data: Object
  },
  mounted() {
    this.addToList()
  },
  data: function (){
    return {
      displayErrors: false,
      form: {},
      ready: false,
      desiredMasks: []
    }
  },
  methods: {
    missingInfoSolo (mask) {
      return (!mask.type || !mask.size)
    },
    setType(i, type) {
      let updated = {...this.desiredMasks[i], type: type}
      this.$set(this.desiredMasks, i, updated)
    },
    setSize(i, size) {
      let updated = {...this.desiredMasks[i], size: size}
      this.$set(this.desiredMasks, i, updated)
    },
    removeFromList(i) {
      let updated = [...this.desiredMasks]
      updated.splice(i,1)
      this.desiredMasks = updated
      this.data.available ++
    },
    addToList() {
      if (this.data.available > 0) {
        let newMask = {
          ...this.data,
          type: null,
          size: null
        }
        delete newMask.available
        this.desiredMasks.push(newMask)
        this.data.available --
        // let element = "mask" + (this.desiredMasks.length -1).toString()
        setTimeout(function(){
          let newRow = document.getElementById("add")
          newRow.scrollIntoView({ behavior: 'smooth', block: 'end' })
        }, 10)

      }
    },
    addToReservation() {
      if (!this.missingInfo) {
        if(localStorage.getItem('oro-reservation')){
          this.$store.commit('addToReservation', this.desiredMasks)
        } else {
          this.$store.commit('initiateReservation', this.desiredMasks)
        }
      } else {
        this.displayErrors = true
      }
    },
    closeModal() {
      // put back all the unused masks
      this.data.available = this.data.available + this.desiredMasks.length
      this.$store.commit('setModal')
    },
    submit() {
      if (this.form.email && this.form.name) {
        this.$store.commit('submitReservation', this.form)
      }
      // console.log("reserving", this.$store.getters.getReservationList)
    }
  },
  computed: {
    missingInfo () {
      // check if all the masks are setup correctly
      let missingInfo = false
      this.desiredMasks.forEach(mask=>{
        if (!mask.type || !mask.size) {
          missingInfo = true
        }
      })
      return missingInfo
    },
    suggestedDonation () {
      return this.data.masks.masks.length * 5
    },
    masksSummary () {
      let summary = {}
      this.data.masks.masks.forEach(mask => {
        if (summary[mask.uuid]) {
          summary[mask.uuid].quantity++
        } else {
          summary[mask.uuid] = {
            name: mask.name,
            thumb: mask.image,
            quantity: 1
          }
        }
      })
      return summary
    },
    totalAvailable() {
      return this.data.available-(this.data.pending ? this.data.pending : 0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.error {
  background: red;
}
input {
  margin: 5px auto;
  width: 90%;
  padding-left: 10px;
}
.summaryItem {
  text-align: left;
  margin: 0 20px;
}
h3, h4 {
   padding: 0;
   margin: 0;
}
h4 {
  font-weight: normal;
  font-size: 18px;
}
.modal-scrollable {
  overflow-y: auto;
  height: 80%;
}
.mask-settings {
  padding: 2px 0;
  margin: 2px auto;
  display: inlne-block;
}
.mask-option-group {
  // border: 1px solid white;
  display: inline-block;
  text-align: center;
  padding: 5px;
}
.mask-option {
  text-align: center;
  display: inlne-block;
  background: none;
  border: 2px solid white;
  border-right: 1px solid white;
  border-left: 1px solid white;
  min-width: 35px;
  height: 40px;
  background: rgba(255,255,255,.8);
  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 1px solid white;
  }
  &:last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-left: 1px solid white;
  }
}
 .delete-button  {
   background: darkred;
   color: white;
   height: 40px;
   border: 2px solid darkred;
   border-radius: 4px;
 }
.selected {
  background: #e9c46a;
  border: #e9c46a;
  font-weight: bold;
}
#add-button, #cancel-button {
  display: inline-block;
  padding: 10px 20px;
  margin: 10px auto 40px;
  background: #e9c46a;
  color: black;
  font-weight: bold;
  border-radius: 5px;
  border: 2px solid #e9c46a;

  &.subdued {
    background: black;
    color: gray;
    border: 2px solid gray;
  }
}

#modal-content {
  background: rgba(0,0,0,.85);
  height: 100%;
  width: 100%;
}
#modal {
  width: 95%;
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background: white;
  height: 70%;
  border: 2px solid black;
  border-bottom: none;
  border-radius: 5px 5px 0 0;
  #modal-title {
    font-weight: bold;
    font-size: 24px;
    padding: 5px 0;
  }
}
#modal-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 20px;
  background: rgba(155,0,0,.9);
  color: white;
  font-weight: bold;
  height: 50px;
  margin: 5px auto 0;
  .modal-footer-button {
    cursor: pointer;
    display: inline-block;
    margin: 0 5px;
    border: 1px solid white;
    padding: 5px 10px;
  }
}
</style>
